import { Grid } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

import { Legend } from "@nens/lizard/api-v4";
import { RanaAlert } from "@nens/ranalib";

import { LegendDiscreteStep } from "./legend-discrete-step";

export interface LegendDiscreteProps {
  legend: Legend["legend"];
  labels: Legend["labels"];
}

export function LegendDiscrete({ legend, labels }: LegendDiscreteProps) {
  const selectedLabels = labels["nl_NL"] || labels["en_EN"];
  if (!selectedLabels) return null;

  const hasNonDiscreteSteps = legend.some((step) => !Number.isInteger(step.value));

  if (hasNonDiscreteSteps) {
    return (
      <RanaAlert status="error">
        <FormattedMessage
          id="legend.nonDiscreteSteps"
          defaultMessage="This raster contains non-discrete data, but the style has been set to a discrete style. Data on the map will not be displayed correctly. Please change the style."
        />
      </RanaAlert>
    );
  }

  return (
    <Grid columnGap={1} templateColumns="1fr">
      {legend.map((step, i) => {
        const label = selectedLabels[step.value] || "Other";
        return (
          <LegendDiscreteStep key={step.value + step.color + i} label={label} color={step.color} />
        );
      })}
    </Grid>
  );
}
